<template>
  <div class="VendorCreate">
    <div class="create">
      <div class="top">
        <div style="display: flex;align-items: center">
          <el-button class="return" v-if="vid!=='0'&&back" size="medium" round icon="el-icon-arrow-left"
                     @click="onReturn">
            Return
          </el-button>
          <p class="title">{{vid!=='0'?'Vendor Detail':'Create Vendor'}}</p>
        </div>

        <div class="action">
          <el-button round class="button" size="small" :disabled="!error_check" :type="error_check?'primary':'info'"
                     @click="onSave">Save
          </el-button>
        </div>
      </div>
      <div class="body">
        <!-- Vendor Name -->
        <div class="item">
          <p class="item_name"><span style="color: #F56C6C">*</span> Vendor Name</p>
          <div class="item_input">
            <p>EN</p>
            <el-input size="medium" style="width: 300px" v-model="detail.name_en" placeholder="Enter English Name"
                      maxlength="30" show-word-limit autocomplete="off"></el-input>
          </div>
          <div class="item_input">
            <p>CN</p>
            <el-input size="medium" style="width: 300px" v-model="detail.name_cn" placeholder="Enter Chinese Name"
                      maxlength="30" show-word-limit autocomplete="off"></el-input>
          </div>
        </div>

        <!-- Vendor Info -->
        <div class="item">
          <p class="item_name"><span style="color: #F56C6C">*</span> Vendor Info</p>
          <div class="item_input">
            <p>EN</p>
            <el-input
                type="textarea"
                style="width: 500px"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="Enter English Info"
                v-model="detail.info_en">
            </el-input>
          </div>
          <div class="item_input">
            <p>CN</p>
            <el-input
                type="textarea"
                style="width: 500px"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="Enter Chinese Info"
                v-model="detail.info_cn">
            </el-input>
          </div>
        </div>

        <!-- Vendor Phone -->
        <div class="item">
          <p class="item_name"><span style="color: #F56C6C">*</span> Vendor Phone</p>
          <div class="item_input">
            <el-input size="medium" style="width: 300px" v-model="detail.vendor_phone" placeholder="Enter Phone Number"
                      maxlength="30" autocomplete="off"></el-input>
          </div>
        </div>

        <!-- Vendor Location -->
        <div class="item">
          <p class="item_name"><span style="color: #F56C6C">*</span> Vendor Address</p>
          <div class="item_input">
            <p>EN</p>
            <el-input size="medium" style="width: 400px" v-model="detail.address_en" placeholder="Enter English Address"
                      maxlength="40" show-word-limit autocomplete="off"></el-input>
          </div>
          <div class="item_input">
            <p>CN</p>
            <el-input size="medium" style="width: 400px" v-model="detail.address_cn" placeholder="Enter Chinese Address"
                      maxlength="40" show-word-limit autocomplete="off"></el-input>
          </div>
          <el-button class="gps" :type="detail.vendor_lat!==0&&detail.vendor_lng!==0?'primary':''" @click="onMapShow">
            {{detail.vendor_lat!==0&&detail.vendor_lng!==0?'Selected':'GPS'}} <i class="el-icon-s-promotion"></i>
          </el-button>
        </div>

        <!-- Vendor Location -->
        <div class="item_line">
          <p class="item_name" style="float: left" ><span style="color: #F56C6C">*</span> Location</p>
          <el-select size="small" v-model="detail.location_id" style="width: 160px;float: right" filterable
                     placeholder="Select category">
            <el-option
                v-for="item in location_list"
                :key="item.ven_location_id"
                :label="item.ven_location_name_en"
                :value="item.ven_location_id">
            </el-option>
          </el-select>
        </div>

        <!-- Vendor Category -->
        <div class="item_line">
          <p class="item_name" style="float: left"><span style="color: #F56C6C">*</span> Category</p>
          <el-select size="small" v-model="detail.category_id" style="width: 160px;float: right" filterable
                     placeholder="Select category">
            <el-option
                v-for="item in category_list"
                :key="item.category_id"
                :label="item.category_name_en"
                :value="item.category_id">
            </el-option>
          </el-select>
        </div>

        <div class="upload_abs">
          <!-- Banner Upload -->
          <div class="upload">
            <p><span style="color: #F56C6C">*</span> Upload Banner Images (Up to 6)</p>
            <ImageUpload :limit="6" target="banner" :input="vid!=='0'?detail.banner_images:[]"
                         @output="onUpdateImage"></ImageUpload>
          </div>

          <!-- Detail Upload -->
          <div class="upload">
            <p><span style="color: #F56C6C">*</span> Upload Detail Images (Up to 3)</p>
            <ImageUpload :limit="3" target="detail" :input="vid!=='0'?detail.detail_images:[]"
                         @output="onUpdateImage"></ImageUpload>
          </div>

          <!-- Detail Video Upload -->
          <div class="upload" v-if="video">
            <p>Upload Vendor Video (Up to 1) (Optional)</p>
            <VideoUpload style="margin-bottom: 20px" :input="vid!=='0'?detail.vendor_video_url:''"
                         @remove="onRemoveVideo" @output="onUpdateVideo"></VideoUpload>
          </div>
        </div>
      </div>
    </div>

    <!-- Vendor Review -->
    <div class="review" v-if="vid!=='0'&&rate">
      <div class="review_header">
        <div class="review_title">Reviews</div>
      </div>

      <div class="review_body" @scroll="onScrollReview">
        <template v-if="review_list.length!==0">
          <Review v-for="review in review_list"
                  :key="review.review_id"
                  :review="review"></Review>
        </template>

        <p v-if="review_list.length===0">No review</p>
      </div>
    </div>

    <el-dialog class="dialog" :visible.sync="dialog_visible">
      <Map @confirm="onLocationConfirm" :vlat="detail.vendor_lat" :vlng="detail.vendor_lng"></Map>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getVendorCategory, getVendorDetail,
    getVendorLocation,
    recentReview,
    saveVendorDetail
  } from "@/utils/api";
  import ImageUpload from "@/components/Images/Images";
  import VideoUpload from "@/components/Videos/Videos";
  import Review from "@/components/Review/Review";
  import Map from "@/components/Map/Map";

  export default {
    props: ['mode', 'vid', 'back', 'rate', 'video'],
    components: {
      ImageUpload,
      VideoUpload,
      Review,
      Map
    },
    data: () => {
      return {
        detail: {
          id: '',
          name_en: '',
          name_cn: '',
          info_en: '',
          info_cn: '',
          address_en: '',
          address_cn: '',
          vendor_lat: 0,
          vendor_lng: 0,
          vendor_phone: '',
          category_id: '',
          location_id: '',
          banner_images: [],
          detail_images: [],
          video_path: '',
          video_ratio: 16 / 9,
        },
        category_list: [],
        location_list: [],
        error_check: false,
        review_list: [],
        dialog_visible: false
      }
    },
    watch: {
      detail: {
        handler(n) {
          let error = 0;
          let check = [
            n.name_en !== '',
            n.name_cn !== '',
            n.info_en !== '',
            n.info_cn !== '',
            n.address_en !== '',
            n.address_cn !== '',
            n.category_id !== '',
            n.location_id !== '',
            n.vendor_lat !== 0,
            n.vendor_lng !== 0,
            n.vendor_phone !== '',
            n.banner_images.length !== 0,
            n.detail_images.length !== 0,
          ];
          check.forEach(v => {
            if (!v) {
              error += 1
            }
          });
          this.error_check = error === 0;
        },
        deep: true
      }
    },
    methods: {
      onLocationConfirm(e) {
        this.detail.vendor_lat = e.lat;
        this.detail.vendor_lng = e.lng;
        this.dialog_visible = false
      },
      onMapShow() {
        this.dialog_visible = true
      },
      onReturn() {
        this.$emit('return')
      },
      onSave() {
        this.$showLoading();
        saveVendorDetail(this.detail).then(res => {
          this.$hideLoading();
          if (res.errcode === 0) {
            this.$message.success('Vendor Saved');
            this.$emit('back')
          } else {
            this.$message.error('Error in saving vendor')
          }
        })
      },

      onUpdateImage(e) {
        if (e.target === 'banner') {
          this.detail.banner_images = e.image_list
        } else if (e.target === 'detail') {
          this.detail.detail_images = e.image_list
        }
      },
      onUpdateVideo(e) {
        this.detail.video_path = e.video_path;
        this.detail.video_ratio = e.video_ratio
      },
      onRemoveVideo() {
        this.detail.video_path = '';
        this.detail.video_ratio = 16 / 9
      },

      onScrollReview(event) {
        let scroll_total = event.target.scrollHeight;
        let scroll_current = event.target.scrollTop + event.target.offsetHeight;
        let interval = 2000;
        if (scroll_total - scroll_current <= 20 && !this.scroll_block) {
          this.scroll_block = true;
          this.getRecentReview(this.vid);
          setTimeout(() => {
            this.scroll_block = false;
          }, interval)
        }
      },
      getRecentReview(id) {
        let type = 'vendor';
        let start = this.review_list.length;
        recentReview(type, id, start, 10).then(res => {
          if (res.errcode === 0) {
            this.review_list = this.review_list.concat(res.review_list);
          } else {
            this.$message.error(res.errmsg);
          }
        })
      }
    },
    beforeMount() {
      if (this.vid !== '0') {
        getVendorDetail(this.vid).then(res => {
          let d = res.detail;
          d.id = this.vid;
          d.name_en = d.vendor_name_en;
          d.name_cn = d.vendor_name_cn;
          d.info_en = d.vendor_info_en;
          d.info_cn = d.vendor_info_cn;
          d.address_en = d.vendor_address_en;
          d.address_cn = d.vendor_address_cn;
          d.video_path = d.vendor_video_url;
          d.video_ratio = d.vendor_video_ratio;
          this.detail = d;
        });
        if (this.rate) {
          this.getRecentReview(this.vid);
        }
      }
      getVendorCategory().then(res => {
        if (res.errcode === 0) {
          // res.category_list.unshift({
          //   category_id: '0',
          //   category_name_en: '#Uncategorized'
          // });
          this.category_list = res.category_list
        } else {
          this.$message.error('Error in getting categories')
        }
      });
      getVendorLocation().then(res => {
        if (res.errcode === 0) {
          // res.location_list.unshift({
          //   ven_location_id: '0',
          //   ven_location_name_en: '#Unspecified'
          // });
          this.location_list = res.location_list
        } else {
          this.$message.error('Error in getting locations')
        }
      });
    }
  };
</script>

<style lang="scss" scoped>
  @import "_VendorCreate.scss";
</style>